import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import AniLink from "gatsby-plugin-transition-link/AniLink";
import { MailOutlined, PhoneOutlined, WhatsAppOutlined, EnvironmentOutlined, FacebookOutlined, InstagramOutlined, TwitterOutlined, UpOutlined } from '@ant-design/icons';
import FooterIMG from '../images/fondofooter2.jpg';
import Logo from './logo';

const ContainerCustom = styled.div`
  margin: 0 3rem;
  background-image: url(${FooterIMG});
  background-size: cover; /* Ajustar el tamaño de la imagen al contenedor */
  background-position: center; /* Centrar la imagen */
`;

const Footer = styled.footer`
  padding: 1rem 0 0;
  background-image: url(${FooterIMG});
  background-size: cover; /* Ajustar el tamaño de la imagen al contenedor */
  background-position: center; /* Centrar la imagen */
`;

const FooterText = styled.p`
  color: white;
  font-size: 1rem;
  text-align: justify;
`;

const InfoList = styled.ul`
  list-style: none;
  padding: 0;
  top:4rem;
  color: #00163b; /* Texto azul */
`;

const InfoItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 0.7rem;
  
  svg {
    margin-right: 0.5rem;
    color: #00163b; /* Iconos azules */
  }
`;

const InfoLink = styled.a`
  color: #00163b; /* Enlaces azules */
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const NavCont = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const SocialCont = styled.div`
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 0.5rem;
    color: #00163b; /* Iconos de redes sociales azules */
  }
`;

const SocialItem = styled.span`
  margin-right: 0.5rem;
  color: #00163b; /* Texto azul */
`;

const SocialLink = styled.a`
  color: #00163b; /* Enlaces azules */
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
`;

const BackTop = styled.button`
  display: flex;
  justify-content: center;
  border: none;
  cursor: pointer;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${props => props.theme.primaryColor};
  margin-bottom: 1rem;
  transition: 250ms ease;
  color: #fff;
  box-shadow: 0px 1px 1px rgba(0, 0, 0, .12),
              0px 2px 2px rgba(0, 0, 0, .12),
              0px 4px 4px rgba(0, 0, 0, .12),
              0px 8px 8px rgba(0, 0, 0, .12);
  &:hover{
    filter: brightness(1.1);
  };
  &:active{
    box-shadow: none;
  }
`;

const CopyrightCont = styled.div`
  padding: .3rem 0;
  color: #fff;
  background-color: transparent;
  font-size: .7rem;
  margin-top: 1rem;
`;

const CopyrightInnerCont = styled.div`
  display: flex;
  justify-content: space-between;
`;

const DevelopedBy = styled.a`
  color: #fff !important;
  transition: 250ms ease;
  font-weight: bold;
  &:hover{
    text-decoration: underline !important;
  }
`;

export default () => {
  const state = useContext(context);

  return (
    <Footer>
      <ContainerCustom>
        <Row className="align-items-center">
          {/* Columna 1: Logo */}
          <Col xs={12} md={4}>
            <AniLink paintDrip hex={state.primaryColor} to="/" duration={.5}>
              <Logo style={{ filter: 'brightness(0) invert(1)' }} />
            </AniLink>
          </Col>

          {/* Columna 2: Teléfonos 
          <Col xs={12} md={4}>
            <InfoList>
              {state.phone && (
                <InfoItem>
                  <PhoneOutlined />
                  <InfoLink title="Llamar" href={`tel:${state.phone.replace(/\s/g,'')}`}>
                    {state.phone}
                  </InfoLink>
                </InfoItem>
              )}
              {state.phone2 && (
                <InfoItem>
                  <PhoneOutlined />
                  <InfoLink title="Llamar" href={`tel:${state.phone2.replace(/\s/g,'')}`}>
                    {state.phone2}
                  </InfoLink>
                </InfoItem>
              )}
            </InfoList>
          </Col>

          {/* Columna 3: WhatsApp 
          <Col xs={12} md={4}>
            <InfoList>
              {state.movil && (
                <InfoItem>
                  <WhatsAppOutlined />
                  <InfoLink title="Enviar WhatsApp" rel="noopener" target="_blank" href={`https://api.whatsapp.com/send?phone=${state.movil.replace(/\s/g,'')}&text=Hola,%20estoy%20visitando%20su%20sitio%20Web%20y%20quisiera%20comunicarme%20con%20uestedes.`}>
                    {state.movil}
                  </InfoLink>
                </InfoItem>
              )}
              {state.movil2 && (
                <InfoItem>
                  <WhatsAppOutlined />
                  <InfoLink title="Enviar WhatsApp" rel="noopener" target="_blank" href={`https://api.whatsapp.com/send?phone=${state.movil2.replace(/\s/g,'')}&text=Hola,%20estoy%20visitando%20su%20sitio%20Web%20y%20quisiera%20comunicarme%20con%20uestedes.`}>
                    {state.movil2}
                  </InfoLink>
                </InfoItem>
              )}
            </InfoList>
          </Col>
        </Row>

        <Row className="align-items-center mt-3">
          {/* Columna 4: Dirección e Información de Contacto */}
          <Col xs={12} md={4}>
            <InfoList>
              {state.address && (
                <InfoItem>
                  <EnvironmentOutlined />
                  {state.address}
                </InfoItem>
              )}
             
              
            </InfoList>
          </Col>

          {/* Columna 5: Redes Sociales */}
          <Col xs={12} md={4}>
            <SocialCont>
              <SocialItem>Síguenos en:</SocialItem>
              <SocialLink href={state.facebook} rel="noopener" target="_blank">
                <FacebookOutlined />
              </SocialLink>
              <SocialLink href={state.instagram} rel="noopener" target="_blank">
                <InstagramOutlined />
              </SocialLink>
              <SocialLink href={state.twitter} rel="noopener" target="_blank">
                <TwitterOutlined />
              </SocialLink>
              
            </SocialCont>
          </Col>
        </Row>
      </ContainerCustom>

      <CopyrightCont>
        <ContainerCustom>
          <CopyrightInnerCont>
            <span>{new Date().getFullYear()} © Todos los derechos reservados</span>
            <div>
              Desarrollado por <DevelopedBy href="https://www.nexxos.cl" rel="noopener" target="_blank">Nexxos Chile</DevelopedBy>
            </div>
          </CopyrightInnerCont>
        </ContainerCustom>
      </CopyrightCont>
    </Footer>
  );
}



/*<NavList>
  <NavItem>
    <AniLink paintDrip hex={state.primaryColor} to="/properties" duration={.5}>
      <NavLink first>
        Propiedades
      </NavLink>
    </AniLink>            
  </NavItem>
  <NavItem>
    <AniLink paintDrip hex={state.primaryColor} to="/about" duration={.5}>
      <NavLink>
        Nosotros
      </NavLink>
    </AniLink>            
  </NavItem>                  
  <NavItem>
    <AniLink paintDrip hex={state.primaryColor} to="/contact" duration={.5}>
      <NavLink >
        Contacto
      </NavLink>
    </AniLink>                                    
  </NavItem>
  <NavItem>
    <AniLink href={`http://nexxos.prop360.cl`} target="_blank" rel="noopener" duration={.5}>
      <NavLink >
        Login
      </NavLink>
    </AniLink>            
</NavItem>  
</NavList> 
<FooterText>
              Somos Arco Gestión, una empresa con varios años de trayectoria en el dinámico mercado inmobiliario, reconocidos por un servicio altamente personalizado y eficiente.
              </FooterText>*/